// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActivitySummaryRecordDto
 */
export interface IClaimActivitySummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimActivitySummaryRecordDto
     */
    claim_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivitySummaryRecordDto
     */
    claim_status?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivitySummaryRecordDto
     */
    count?: number;
}

/**
 * Check if a given object implements the IClaimActivitySummaryRecordDto interface.
 */
export function instanceOfIClaimActivitySummaryRecordDto(value: object): value is IClaimActivitySummaryRecordDto {
    return true;
}

export function IClaimActivitySummaryRecordDtoFromJSON(json: any): IClaimActivitySummaryRecordDto {
    return IClaimActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IClaimActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_type': json['claim_type'] == null ? undefined : json['claim_type'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function IClaimActivitySummaryRecordDtoToJSON(json: any): IClaimActivitySummaryRecordDto {
    return IClaimActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IClaimActivitySummaryRecordDtoToJSONTyped(value?: IClaimActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_type': value['claim_type'],
        'claim_status': value['claim_status'],
        'count': value['count'],
    };
}

